import { Button, Checkbox, Form, Input, message, Select, Space } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";
import { serverFetch } from "../../../server";
import { dictsGetCalendars } from "../../../extensions/dicts";
import { userRoles } from "../../../extensions/helper";
import TakePhoto from "../../../controls/take-photo/take-photo";
import UploadPhoto from "../../../controls/take-photo/upload-photo";
import "./user.css";
import { LogMonitor } from "@/controls";
import { isMobile } from "@/extensions/design";
import { licenseModuleAccessControl } from "@/extensions";

const UserMain = ({ id, onClose, companyId }) => {
  const defaultItem = { vid: 1, active: true, markVid: 0, companyId };
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [calendars, setCalendars] = useState([])
  const imageRef = useRef(null);
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [takePhoto, setTakePhoto] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(false);
  const [hasSkdLicense, setHasSkdLicense] = useState(false);
  const [loadingLastCard, setLoadingLastCard] = useState(false);

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`user/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else {
      form.setFieldsValue(defaultItem);
    }
  }

  useEffect(getData, [id, form])

  useEffect(() => dictsGetCalendars(setCalendars), [])
  useEffect(() => {
    serverFetch("company/current")
      .then((data) => setHasSkdLicense(licenseModuleAccessControl(data?.activeLicense?.activeModules)))
      .catch((e) => message.error(e.userMessage));
  }, []);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  }; 

  const onSave = () => {
    setLoading(true)
    serverFetch("user", { method: id ? "PUT" : "POST", bodyData: item })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onClosePhoto = (refresh) => {
    setTakePhoto(false);
    refresh && getData();
  }
  const onCloseUpload = (refresh) => {
    setUploadPhoto(false);
    refresh && getData();
  }

  const onSavePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    serverFetch(`user/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        setImageVersion(Date.now());
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };
  const onDeletePhoto = () => {
    const formData = new FormData();
    serverFetch(`user/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        setImageVersion(Date.now());
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onCancel = () => onClose()

  const onGetLastDeniedCard = () => {
    setLoadingLastCard(true);
    serverFetch("company/LastDeniedCard")
      .then((card) => {
        setItem((prev) => ({ ...prev, card: card ?? "" }));
        form.setFieldValue("card", card ?? "");
      })
      .catch((e) => message.error(e.userMessage))
      .finally(() => setLoadingLastCard(false));
  };

  return !isMobile ? <>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 7 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
      <Form.Item name="active" valuePropName="checked" label=" " labelCol={{ span: 5 }} wrapperCol={{ span: 24 }}><Checkbox>Активный</Checkbox></Form.Item>
      <div className="user-photo-div">
        <div>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          <Form.Item label="Почта" name="email"><Input /></Form.Item>
          <Form.Item name="login" valuePropName="checked" label=" "><Checkbox>Вход</Checkbox></Form.Item>
          {/* <Form.Item name="admin" valuePropName="checked" label=" "><Checkbox>Администратор</Checkbox></Form.Item> */}
          <Form.Item label="Календарь" name="calendarId"><Select options={calendars} allowClear/></Form.Item>
          <Form.Item label="Должность" name="position"><Input /></Form.Item>
          <Form.Item label="Роль" name="role"><Select options={userRoles}/></Form.Item>
          <Form.Item label="Карта">
            <Space.Compact className="user-card-compact" style={{ width: "100%" }}>
              <Form.Item name="card" noStyle><Input /></Form.Item>
              {hasSkdLicense && (
                <Button
                  type="default"
                  className="user-card-compact-btn"
                  icon={<CreditCardOutlined />}
                  onClick={onGetLastDeniedCard}
                  loading={loadingLastCard}
                  title="Получить последнюю карту СКД"
                />
              )}
            </Space.Compact>
          </Form.Item>
          <Form.Item label=" " name="skd" valuePropName="checked"><Checkbox>Свободный доступ СКД</Checkbox></Form.Item>
        </div>
        {id && <div className="user-photo">
          <img ref={imageRef} src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/sample.png"} alt="user" className="user-photo-picture" />
          <img src="/images/photo.svg" alt="take-photo" className="user-photo-button" onClick={() => setTakePhoto(true)} />
          <img src="/images/upload-photo.svg" alt="upload-photo" className="user-photo-upload-button" onClick={() => setUploadPhoto(true)} />
          {item?.imageId && <img src="/images/delete-button.svg" alt="delete-photo" className="user-photo-delete-button" onClick={() => onDeletePhoto()} />}
        </div>}
        {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
        {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
      </div>
      <Form.Item label=" ">
        <Space>
          <Button className="sport-btn" onClick={onSave} disabled={item.login && !item.email}>Сохранить</Button>
          <LogMonitor vid={8} id={id}/>
          <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
        </Space>
      </Form.Item>
    </Form>
  </> :
  <div className="product-mobile-container">
    <div style={{marginTop: "4px"}}>
      <Button style={{width: "100%"}} onClick={onSave} disabled={item.login && !item.email}>Сохранить</Button>
    </div>
    <div className="product-mobile-scroll">
      <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 3 }} colon={false} disabled={loading} layout="inline">
        <Form.Item className="settings-mobile-form-item" label="Имя" name="name">
          <Input/>
        </Form.Item>
        <Form.Item className="settings-mobile-form-item" label="Почта" name="email">
          <Input/>
        </Form.Item>
        <Form.Item className="settings-mobile-form-item" label="Должность" name="position">
          <Input/>
        </Form.Item>
        <Form.Item className="settings-mobile-form-item" label="Карта">
          <Space.Compact className="user-card-compact" style={{ width: "100%" }}>
            <Form.Item name="card" noStyle>
              <Input/>
            </Form.Item>
            {hasSkdLicense && (
              <Button
                type="default"
                className="user-card-compact-btn"
                icon={<CreditCardOutlined />}
                onClick={onGetLastDeniedCard}
                loading={loadingLastCard}
                title="Получить последнюю карту СКД"
              />
            )}
          </Space.Compact>
        </Form.Item>
        <Form.Item label="Роль" name="role" className="settings-mobile-form-item">
          <Select options={userRoles}/>
        </Form.Item>
        <Form.Item label="Календарь" name="calendarId" className="settings-mobile-form-item">
          <Select options={calendars} allowClear/>
        </Form.Item>
        <div className="client-item-line-triple-halfed ">
          <Form.Item label="Актив." name="active" valuePropName="checked" className="record-form-item-with-margin-top-mobile">
            <Checkbox/>
          </Form.Item>
          <Form.Item label="Вход" name="login" valuePropName="checked" className="record-form-item-with-margin-top-mobile">
            <Checkbox/>
          </Form.Item>
          <Form.Item label="СКД" name="skd" valuePropName="checked" className="record-form-item-with-margin-top-mobile">
            <Checkbox/>
          </Form.Item>
        </div>
        {id && <Form.Item label="Фото" className="record-form-item-with-margin-top-mobile product-photo-form-item" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }} style={{ marginBottom: 16 }}>
          <div className="product-photo-mobile">
            <img ref={imageRef} src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/sample.png"} alt="user" className="product-photo-picture-mobile" />
            <div className="product-photo-buttons-mobile">
              <img src="/images/photo.svg" alt="take-photo" style={{ cursor: 'pointer' }} onClick={() => setTakePhoto(true)} />
              <img src="/images/upload-photo.svg" alt="upload-photo" style={{ cursor: 'pointer' }} onClick={() => setUploadPhoto(true)} />
              {item?.imageId ? <img src="/images/delete-button.svg" alt="delete-photo" style={{ cursor: 'pointer', height: 28, width: 28 }} onClick={() => onDeletePhoto()} /> : null}
            </div>
          </div>
          {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
          {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
        </Form.Item>}
      </Form>
    </div>
  </div>
}

export default UserMain;

